import { ChartData, ChartOptions } from "chart.js";
import { FC } from "react";
import { Chart } from "react-chartjs-2";

interface AreaChartProps {
    data: ChartData<'line'>,
    options?: ChartOptions<"line">
}

export const AreaChart: FC<AreaChartProps> = ({ data, options }) => {
    const opts: ChartOptions<"line"> = {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
            line: {
                tension: 0.4
            },
            point: {
                radius: 0
            }
        },
        scales: {
            y: {
                ticks: {
                    maxTicksLimit: 10
                },
                border: {
                    dash: [8, 4],
                    color: 'rgba(0, 0, 0, 0)'
                },
            },
            x: {
                grid: {
                    drawOnChartArea: false
                },
                border: {
                    color: 'rgba(0, 0, 0, 0)'
                }
            },
        },
        plugins: {
            legend: {
                display: false
            }
        },
        interaction: {
            intersect: false,
            mode: 'index',
        },
        ...options
    }
    return (
        <Chart 
            type={'line'} 
            data={data} 
            options={opts}
        />
    )
}